import { ChatCircle, Trophy, GameController, Calendar } from '@phosphor-icons/react';

export const ProfileStats = ({ user, rank, totalPlayers, gamesPlayedCount, favoriteGameName }) => {
  const memberSince = new Date(user.created_at).toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric'
  });

  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <StatCard
          icon={<ChatCircle size={20} weight="fill" className="text-[#0047FF]" />}
          value={user.messages_count}
          label="Messages Sent"
          testId="stat-messages"
        />
        <StatCard
          icon={<Trophy size={20} weight="fill" className="text-[#0047FF]" />}
          value={`#${rank}`}
          label={`of ${totalPlayers} Players`}
          testId="stat-rank"
        />
        <StatCard
          icon={<GameController size={20} weight="fill" className="text-[#0047FF]" />}
          value={gamesPlayedCount}
          label="Games Played"
          testId="stat-games"
        />
        <StatCard
          icon={<Calendar size={20} weight="fill" className="text-[#0047FF]" />}
          value={memberSince}
          label="Member Since"
          testId="stat-member-since"
          isDate
        />
      </div>

      {favoriteGameName && (
        <div className="p-4 border border-[#E4E4E7] bg-[#FAFAFA]" data-testid="favorite-game">
          <p className="text-xs font-medium text-[#71717A] uppercase tracking-wider mb-1">Favorite Game</p>
          <p className="text-lg font-medium text-[#09090B]">{favoriteGameName}</p>
        </div>
      )}
    </>
  );
};

const StatCard = ({ icon, value, label, testId, isDate = false }) => (
  <div className="p-4 border border-[#E4E4E7] bg-white" data-testid={testId}>
    <div className="flex items-center gap-3 mb-2">
      <div className="bg-[#FAFAFA] p-2">
        {icon}
      </div>
      <div>
        <p className={`${isDate ? 'text-lg' : 'text-2xl'} font-mono font-bold text-[#09090B]`}>
          {typeof value === 'number' ? value.toLocaleString() : value}
        </p>
        <p className="text-xs text-[#71717A]">{label}</p>
      </div>
    </div>
  </div>
);
